import Hero from "@/components/Hero";
import BeforeAfter from "@/components/BeforeAfter";
import { FAQSection, GallerySection, Testimonials } from "@/components/Showcase";
import { CTABanner, FinalCTA, ProcessSteps, WhyUs } from "@/components/Marketing";
import { Overline, Reveal } from "@/components/Reveal";
import { SEO } from "@/components/SEO";

const ServicePage = ({ service }) => (
  <>
    <SEO title={service.metaTitle} description={service.metaDesc} />
    <Hero
      overline={`${service.name} · Huntsville, Madison & Athens`}
      lines={[
        { text: service.tagline.split(",")[0] + "," },
        { text: "Done Right the First Time.", accent: true },
      ]}
      sub={service.description}
      bullets={service.bullets}
      image={service.heroImage}
      imageAlt={`${service.name} in Huntsville, Alabama`}
      formTitle={`Free ${service.name} Estimate`}
      formSource={`${service.slug}-hero`}
      idPrefix="service-hero"
    />

    <section className="bg-white py-16 md:py-24" data-testid="whats-included-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Overline>What's Included</Overline>
          <h1 className="mt-3 max-w-3xl font-serif text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">
            {service.h1}
          </h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-600">
            Serving Huntsville, Madison, Athens and the surrounding counties. Every {service.short.toLowerCase()} project below is handled by our own crew — never subcontracted out.
          </p>
        </Reveal>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {service.includes.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.06}>
              <div className="h-full rounded-2xl border border-slate-200 bg-cream p-6 transition-all duration-300 hover:-translate-y-1 hover:border-salmon/40 hover:shadow-lg">
                <span className="font-serif text-2xl font-bold text-salmon/40">{String(i + 1).padStart(2, "0")}</span>
                <h2 className="mt-2 font-sans text-lg font-semibold text-navy">{item.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <CTABanner title={`Ready to start your ${service.short.toLowerCase()} project?`} />
    <ProcessSteps />
    {service.slug === "bathroom-remodeling" && <BeforeAfter />}
    <GallerySection heading={`Recent ${service.name} Projects`} />
    <WhyUs title={`Why North Alabama Trusts Us With Their ${service.short}`} />
    <FAQSection faqs={service.faqs} heading={`${service.name} FAQs`} />
    <Testimonials />
    <FinalCTA heading={`Get Your Free ${service.name} Estimate`} />
  </>
);

export default ServicePage;
